import { z } from 'zod';

export const LoginSchema = z.object({
  username: z.string().trim().min(2).max(64),
  password: z.string().min(8).max(200),
});

export type LoginInput = z.infer<typeof LoginSchema>;

export const RefreshSchema = z.object({
  refreshToken: z.string().uuid(),
});

export type RefreshInput = z.infer<typeof RefreshSchema>;

export const PasswordChangeSchema = z
  .object({
    currentPassword: z.string().min(8).max(200),
    newPassword: z
      .string()
      .min(12, 'Минимум 12 символов')
      .max(200)
      .regex(/[A-Za-zА-Яа-я]/, 'Добавьте хотя бы одну букву')
      .regex(/\d/, 'Добавьте хотя бы одну цифру'),
  })
  .refine((d) => d.currentPassword !== d.newPassword, {
    message: 'Новый пароль должен отличаться от текущего',
    path: ['newPassword'],
  });

export type PasswordChangeInput = z.infer<typeof PasswordChangeSchema>;

export interface TokenPairResponse {
  accessToken: string;
  accessExpiresAt: string;
  refreshToken: string;
  refreshExpiresAt: string;
}
